import type { ToothSliceGeometryMode } from '@/shared/graphics/medicalImageRender/MedicalImageRender';

export const parseToothSliceMode = (
  value: string | null,
  fallback: ToothSliceGeometryMode = 'series',
): ToothSliceGeometryMode => {
  if (value === 'series' || value === 'orthogonal') {
    return value;
  }

  return fallback;
};
